module.exports = __webpack_public_path__ + "images/emoji/hash.17de607bda460a8ee52b.png";